module.exports = __webpack_public_path__ + "static/media/oberflex-zebranonaturel-1200x2490.4ce9c8ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranonaturel-1200x2490.jpg
// module id = 1084
// module chunks = 37